
namespace RioERP.Reports {
    export class FranchiseeSalesReportColumns {
        static columnsKey = 'Reports.FranchiseeSalesReport';
    }
}